import { Component } from '@angular/core';

@Component({
  selector: 'mtm-master-icon',
  templateUrl: './master-icon.component.html',
  styleUrl: './master-icon.component.scss',
  standalone: false,
})
export class MasterIconComponent {}
